import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
	selector: "distribution-article-dialog",
	templateUrl: "./distribution-article-dialog.html",
	styleUrl: "./distribution-article-dialog.scss",
})
export class DistributionArticleDialogComponent implements OnInit {
	constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
	ngOnInit(): void {
		this.distribution = this.data;
	}
	protected distribution = [];
	openDialog() {}
}
